/* [PATCH izdani-interna-originalna v1] Nastavitev, kako se dolocajo interne
   stevilke IZDANIH racunov (companies.izdani_interna). Shrani se z gumbom
   Shrani zavihka (polje gre v PUT /profil kot ostala profilna polja). */
import React from 'react';
import { Hash } from 'lucide-react';

export function IzdaniInternaKartica({ data, set }: {
  data: any;
  set: (field: string, value: any) => void;
}) {
  const izbrano = String(data?.izdani_interna || 'zaporedna');

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-blue-600 flex items-center justify-center">
          <Hash className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Interna številka izdanih računov</h2>
          <p className="text-xs text-gray-500">Kaj je interna številka izdanega računa in kaj gre v izvoz (VOD polje Številka dokumenta).</p>
        </div>
      </div>
      <div className="mt-4 space-y-2">
        <label className="flex items-start gap-2 cursor-pointer">
          <input type="radio" name="izdani_interna" className="mt-0.5"
            checked={izbrano === 'zaporedna'}
            onChange={() => set('izdani_interna', 'zaporedna')} />
          <span className="text-sm">
            <span className="font-medium text-gray-800 dark:text-gray-200">Zaporedna</span>{' '}
            <span className="text-gray-500">— zaporedna številka po seriji, s predpono, če je nastavljena.</span>
          </span>
        </label>
        <label className="flex items-start gap-2 cursor-pointer">
          <input type="radio" name="izdani_interna" className="mt-0.5"
            checked={izbrano === 'originalna'}
            onChange={() => set('izdani_interna', 'originalna')} />
          <span className="text-sm">
            <span className="font-medium text-gray-800 dark:text-gray-200">Originalna številka računa</span>{' '}
            <span className="text-gray-500">— interna = predpona + številka z računa (npr. 26SKL-MK-3141); brez številke ostane prazna.</span>
          </span>
        </label>
      </div>
    </div>
  );
}
